import React from 'react';
import PropTypes from 'prop-types';

import { Alert, Spacer } from '@zillow/constellation';

import { PartialMessage } from '@zg-rentals/backend-styled-components';

import PropertyConstants from '../../../constants/PropertyConstants';

const propTypes = {
  universal: PropTypes.object,
  syndicationStatus: PropTypes.string,
};

const defaultProps = {
  universal: null,
  syndicationStatus: '',
};

const ListingStatusBanner = ({ universal, syndicationStatus }) => {
  if (
    !universal ||
    universal.partialMessages.length < 1 ||
    syndicationStatus === PropertyConstants.SYNDICATION_OVERVIEW_STATUS.INACTIVE
  ) {
    return null;
  }

  return (
    <Spacer marginBottom="md">
      <Alert appearance="info" body={<PartialMessage partialMessages={universal.partialMessages} />} />
    </Spacer>
  );
};

ListingStatusBanner.propTypes = propTypes;
ListingStatusBanner.defaultProps = defaultProps;

export { ListingStatusBanner };
export default ListingStatusBanner;
